import BossTrainingTroll from "../animations/bosses/BossTrainingTroll";
import common from "../common";
import QuestionModuleArithmetic from "../maths/modules/QuestionModuleArithmetic";
import QuestionModuleSorting from "../maths/modules/QuestionModuleSorting";
import GelButton from "../ui/gel/GelButton";
import {isEdge18} from "../utils";
import GameScene from "./GameScene";

export default class TrainingScene extends GameScene {
    constructor() {
        super();

        this._state = TrainingScene.STATE_NONE;
        this._nextState = this._state;

        this._questionCount = 3;
        this._partyCount = 0;
        this._incorrectAnswerTweens = new P3.utils.TWEEN.Group();

        this._tutorialHand = null;
        this._tutorialHandTweens = new P3.utils.TWEEN.Group();

        this._currentTutorialVO = null;
        this._guardianAttackDelay = null;
        this._bossAttackDelay = null;

        this._message = null;
    }

    init() {
        super.init();

        const sequence = new P3.MovieClipSequence();
        sequence.addTextures([P3.assets.texture("tutorial_finger")], "default");
        sequence.addTextures([P3.assets.texture("tutorial_finger_tap"), P3.assets.texture("tutorial_finger")], "tap");

        this._tutorialHand = new P3.MovieClip(sequence, "default", false);
        this._tutorialHand.anchor.set(0.1, 0.04);
        this._tutorialHand.hitArea = new PIXI.Rectangle();
        this._tutorialHand.visible = false;
        this._tutorialHand.animationSpeed = 1;
        this.addChild(this._tutorialHand);

        this.initSkipButton(GelButton.TAB_INDEX_LEVEL_3);

        if (!PIXI.utils.isMobile.any) {
            this._calculatorButton.visible = false;
        }
    }

    destroy() {
        this._currentTutorialVO && this._currentTutorialVO.destroy();

        super.destroy();
    }

    appear() {
        this._boss.playEnterAnim();
        P3.utils.delayg(this._tweens, 0, () => {
            this._boss.visible = true;
        });
    }

    start() {
        this.setState(TrainingScene.STATE_INTRO);
    }

    end() {
        this._running = false;
        this.signals.next.dispatch(this);

        // tracking
        common.gmi.sendStatsEvent("level", "complete", {
            metadata:
                "LVL=" + common.location.id + "-" + (common.difficulty.level + 1) +
                "~LVR=" + "Success" +
                "~SCO=" + this._correctCount
        });
    }

    show() {
        super.show();

        this._currentTutorialVO && this._currentTutorialVO.play();

        this.showSkipButton();

        if (!PIXI.utils.isMobile.any) {
            this.showCalculatorButton();
        }
    }

    showSkipButton() {
        if ([
            TrainingScene.STATE_NONE,
            TrainingScene.STATE_INTRO
        ].indexOf(this._state) === -1) {
            this._skipButton.visible = false;
        }
    }

    showCalculatorButton() {
        if ([
            TrainingScene.STATE_NONE,
            TrainingScene.STATE_INTRO,
            TrainingScene.STATE_SELECT,
            TrainingScene.STATE_SELECT_NEXT,
            TrainingScene.STATE_SORT,
            TrainingScene.STATE_SORT_NEXT
        ].indexOf(this._state) !== -1)
            this._calculatorButton.visible = false;
    }

    hide() {
        super.hide();

        this._currentTutorialVO && this._currentTutorialVO.pause();
    }

    update() {
        super.update();

        this._incorrectAnswerTweens.update();
        this._tutorialHandTweens.update();

        const dt = window.dt;
        this.updateFSM(dt);

        this._tutorialHand.visible && this._tutorialHand.update(dt);
    }

    updateFSM(dt) {
        if (typeof this._nextState !== "undefined" && this._nextState !== this._state) {
            this.exitState(this._state);
            this._state = this._nextState;
            this.enterState(this._state);
        }
        this.updateState(this._state);
    }

    createBoss(type) {
        return new BossTrainingTroll();
    }

    createUI() {
        super.createUI();

        this._xpPanel.visible = false;  // no xp for training
    }

    setState(state) {
        this._nextState = state;
    }

    enterState(state) {
        switch (state) {
            default :
            case TrainingScene.STATE_NONE : {
                this._running = false;
                break;
            }
            case TrainingScene.STATE_INTRO : {
                this._running = false;

                let index = 0;
                const vos = ["vo_queen_57", "vo_queen_58", "vo_queen_61b"];

                if (/*isEdge18()*/ false) {
                    this.setState(TrainingScene.STATE_SELECT);
                } else {
                    function next() {
                        if (index < vos.length) {
                            this._currentTutorialVO = P3.audio.playSound(vos[index]);

                            // failsafe for these sounds not existing
                            if (this._currentTutorialVO) {
                                this._currentTutorialVO.signals.end.once(() => next.call(this));
                            } else {
                                next.call(this);
                                return;
                            }

                            const subtitles = P3.assets.json("subtitles");
                            const text = subtitles[vos[index]];

                            this.showMessage(text);

                            switch (index++) {
                                case 0 : {
                                    console.log("tutorial part 1");

                                    // show question counter
                                    P3.utils.delayg(this._tweens, 1.54, () => {
                                        this._questionCounter.animateIn(true);
                                    });

                                    // show guardian attack
                                    this._guardianAttackDelay = P3.utils.delayg(this._tweens, 6.46, () => {
                                        this.player.playAttackAnim();

                                        // todo temp
                                        P3.audio.playSound([
                                            "sfx_guardian_arrow_attack_00",
                                            "sfx_guardian_hammer_attack_00",
                                            "sfx_guardian_magic_attack_00",
                                            "sfx_guardian_spear_attack_00",
                                            "sfx_guardian_spell_attack_00",
                                            "sfx_guardian_sword_attack_00"
                                        ]);
                                    });
                                    break;
                                }
                                case 1 : {
                                    console.log("tutorial part 2");

                                    // show boss attack
                                    this._bossAttackDelay = P3.utils.delayg(this._tweens, 3, () => {
                                        this._boss.playAttackAnim();

                                        // todo temp
                                        P3.audio.playSound([
                                            "sfx_guardian_arrow_attack_00",
                                            "sfx_guardian_hammer_attack_00",
                                            "sfx_guardian_magic_attack_00",
                                            "sfx_guardian_spear_attack_00",
                                            "sfx_guardian_spell_attack_00",
                                            "sfx_guardian_sword_attack_00"
                                        ]);
                                    });
                                    break;
                                }
                                case 2 : {
                                    console.log("tutorial part 3");
                                    break;
                                }
                            }

                            if (common.gmi.getAllSettings().subtitles) {
                                const data = P3.assets.json("subtitles");
                                common.subtitles.show(data[this._currentTutorialVO.howl.name] ?
                                    data[this._currentTutorialVO.howl.name] : this._currentTutorialVO.howl.name, this._currentTutorialVO.howl.duration());
                            }
                        } else {
                            this._currentTutorialVO = null;
                            this.setState(TrainingScene.STATE_SELECT);
                        }
                    }
                    next.call(this);
                }
                break;
            }
            case TrainingScene.STATE_SELECT : {
                this._running = true;
                this.initQuestion(0);
                this._questionInput.showTutorial();

                this.clearMessage();

                this._skipButton.visible = false;

                if (!PIXI.utils.isMobile.any) {
                    P3.audio.playVO("vo_queen_62a", 1, true);
                } else {
                    P3.audio.playVO("vo_queen_64", 1, true);
                }
                break;
            }
            case TrainingScene.STATE_SELECT_NEXT : {
                this.showTutorialHand();
                break;
            }
            case TrainingScene.STATE_SORT : {
                this._running = true;
                this.initQuestion(1);
                this._questionInput.showTutorial();

                if (!PIXI.utils.isMobile.any) {
                    P3.audio.playVO("vo_queen_68", 1, true);
                } else {
                    P3.audio.playVO("vo_queen_69", 1, true);
                }
                break;
            }
            case TrainingScene.STATE_SORT_NEXT : {
                this.showTutorialHand();
                break;
            }
            case TrainingScene.STATE_KEYPAD : {
                this._running = true;
                this.initQuestion(2);
                this._questionInput.showTutorial();

                if (!PIXI.utils.isMobile.any) {
                    this._calculatorButton.scale = 0;
                    const a = new P3.utils.TWEEN.Tween(this._calculatorButton, this._tweens)
                        .to({scale: 1.2}, 440)
                        .easing(P3.utils.Easing.Back2.Out)
                        .onStart(() => {
                            this._calculatorButton.visible = true;
                        });

                    const b = new P3.utils.TWEEN.Tween(this._calculatorButton, this._tweens)
                        .to({scale: 1}, 440)
                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                        .repeat(Infinity)
                        .yoyo(true);


                    a.chain(b);
                    a.start();
                }

                if (!PIXI.utils.isMobile.any) {
                    const a = P3.audio.playVO("vo_queen_71a", 1, true);
                    if (a) {
                        a.signals.end.once(() => {
                            P3.audio.playVO("vo_queen_72a", 1, true);
                        })
                    }
                } else {
                    P3.audio.playVO("vo_queen_70a", 1, true);
                }
                break;
            }
            case TrainingScene.STATE_KEYPAD_NEXT : {
                this.showTutorialHand();
                break;
            }
            case TrainingScene.STATE_OUTRO : {
                this._running = false;
                P3.utils.delayg(this._tweens, 2, () => this.end());
                break;
            }
        }
    }

    exitState(state) {
        switch (state) {
            default :
            case TrainingScene.STATE_NONE : {
                break;
            }
            case TrainingScene.STATE_SELECT_NEXT : {
                this.setState(TrainingScene.STATE_SORT);
                break;
            }
            case TrainingScene.STATE_SORT_NEXT : {
                this.setState(TrainingScene.STATE_KEYPAD);
                break;
            }
        }
    }

    updateState(state) {
        switch (state) {
            default :
            case TrainingScene.STATE_NONE : {
                break;
            }
            case TrainingScene.STATE_SELECT : {
                if (this._questionView.isCorrect()) {
                    this._questionInput.lock();
                    this._questionInput.hideTutorial();
                    this.setState(TrainingScene.STATE_SELECT_NEXT);
                }
                break;
            }
            case TrainingScene.STATE_SORT : {
                if (this._questionView.isCorrect()) {
                    this._questionInput.lock();
                    this._questionInput.hideTutorial();
                    this.setState(TrainingScene.STATE_SORT_NEXT);
                }
                break;
            }
            case TrainingScene.STATE_KEYPAD : {
                if (this._questionView.isCorrect()) {
                    this._questionInput.lock();
                    this._questionInput.hideTutorial();
                    this.setState(TrainingScene.STATE_KEYPAD_NEXT);
                }
                break;
            }
        }
    }

    generateQuestions() {
        const questions = P3.assets.json("questions");

        let data = questions.tutorial[0];
        data.module = "tutorial";
        this._questions[0] = new QuestionModuleArithmetic().create(data);

        data = questions.tutorial[1];
        data.module = "tutorial";
        this._questions[1] = new QuestionModuleSorting().create(data, true);

        data = questions.tutorial[2];
        data.module = "tutorial";
        this._questions[2] = new QuestionModuleArithmetic().create(data);
    }

    animateIncorrectAnswer() {
        const templates = P3.assets.json("templates").templates;
        this._questionView.setHeaderText(P3.utils.selectRandom(P3.utils.objectToArray(templates.tutorial.incorrect)).text);

        this._incorrectAnswerTweens.removeAll();    // stop current animation playing

        this._questionView.header.position.x = 0;   // reset header position

        const strength = 24;
        const duration = 60;

        const a = new P3.utils.TWEEN.Tween(this._questionView.header, this._incorrectAnswerTweens)
            .to({x: strength}, duration * 0.5)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out);

        const b = new P3.utils.TWEEN.Tween(this._questionView.header, this._incorrectAnswerTweens)
            .to({x: -strength}, duration)
            .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
            .repeat(5)
            .yoyo(true);

        const c = new P3.utils.TWEEN.Tween(this._questionView.header, this._incorrectAnswerTweens)
            .to({x: 0}, duration * 0.5)
            .easing(P3.utils.TWEEN.Easing.Cubic.Out);

        a.chain(b);
        b.chain(c);
        a.start();
    }

    showTutorialHand() {
        const local = this._tutorialHand.parent.toLocal(
            this._questionView.confirmButton.position, this._questionView.confirmButton.parent);
        this._tutorialHand.position.set(local.x, local.y);

        this.animateTutorialHand(200);
    }

    hideTutorialHand() {
        this._tutorialHandTweens.removeAll();
        this._tutorialHand.visible = false;
    }

    animateTutorialHand(delay = 0) {
        this._tutorialHandTweens.removeAll();

        this._tutorialHand.alpha = 0;
        const a = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .to({alpha: 1}, 640)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(delay)
            .onStart(() => {
                this._tutorialHand.visible = true;
            });

        const b = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .to({}, 1000)
            .delay(200)
            .onStart(() => {
                this._tutorialHand.gotoAndPlay("tap");
            });

        const c = new P3.utils.TWEEN.Tween(this._tutorialHand, this._tutorialHandTweens)
            .to({alpha: 0}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(() => {
                this._tutorialHand.visible = false;
                this.animateTutorialHand(1000);
            });

        a.chain(b);
        b.chain(c);
        a.start();
    }

    showMessage(text) {
        this.clearMessage();

        this._message = new PIXI.mesh.NineSlicePlane(P3.assets.texture("question_box_9slice"), 88, 44, 88, 44);
        this._message.position.set(common.STAGE_WIDTH * 0.5, this._message.height * 0.5 + 20);
        this._message.width = 740;
        this._message.pivot.set(this._message.width * 0.5, this._message.height * 0.5);
        this.addChild(this._message);

        this._message.label = new PIXI.extras.BitmapText(text, {
            font: {name: "BBC Reith Sans Math", size: 24},
            align: "center",
            tint: 0x0
        });
        this._message.label.position.set(this._message.width * 0.5, this._message.height * 0.5);
        this._message.label.anchor.set(0.5);
        this._message.label.maxWidth = this._message.width - 100;
        this._message.addChild(this._message.label);

        this._message.alpha = 0;
        new P3.utils.TWEEN.Tween(this._message, this._tweens)
            .to({alpha: 1}, 240)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .start();
    }

    clearMessage() {
        if (this._message) {
            this._message.parent.removeChild(this._message);
            this._message = null;
        }
    }

    onQuestionViewConfirm(view, correct) {
        if (!this._running) return;

        if (correct) {
            ++this._correctCount;
            P3.audio.playSound(["music_round_won"]);
        } else {
            P3.audio.playSound(["music_round_lost"]);
        }

        console.log("question:", (this._questionIndex + 1));

        if (correct) {
            this._questionView.visible = false;
            this._questionInput.visible = false;

            this._questionCounter.setAnswer(correct);

            this.hideTutorialHand();

            P3.audio.playSound("sfx_scroll_disappear_00");

            ++this._correctCount;
            this._totalXp += common.config.game.xp[common.difficulty.level] || common.config.game.xp[0];

            this._party[0].playAttackAnim();
            this.animateCamera(true, () => this.damageBoss(), () => {
                next.call(this);

                Math.random() < 0.5 ? this.playGuardianPositiveVO() : this._boss.playDamageVO();
            });

            console.log("potential xp", this._xp);
        } else {
            this._questionView.confirmButton.enabled = true;    // unlock confirm button after press

            this.animateIncorrectAnswer();
        }

        function next() {
            if (this._questionIndex++ < this._questions.length - 1) {
                this.setState(TrainingScene.STATE_NONE);
            } else {
                this.setState(TrainingScene.STATE_OUTRO);
            }

            this._questionCounter.next();

            this.playMusic();
        }
    }

    onSkipButtonClick(button) {
        if (this._currentTutorialVO) {
            this._currentTutorialVO.stop();
            this._currentTutorialVO = null;
        }

        if (this._guardianAttackDelay) {
            this._guardianAttackDelay.stop();
            this._guardianAttackDelay = null;
        }

        if (this._bossAttackDelay) {
            this._bossAttackDelay.stop();
            this._bossAttackDelay = null;
        }

        this.setState(TrainingScene.STATE_SELECT);

        // tracking
        common.gmi.sendStatsEvent("skip", "click");
    }
}

TrainingScene.STATE_NONE        = "none";
TrainingScene.STATE_INTRO       = "intro";
TrainingScene.STATE_SELECT      = "select";
TrainingScene.STATE_SELECT_NEXT = "select_next";
TrainingScene.STATE_SORT        = "sort";
TrainingScene.STATE_SORT_NEXT   = "sort_next";
TrainingScene.STATE_KEYPAD      = "keypad";
TrainingScene.STATE_KEYPAD_NEXT = "keypad_next";
TrainingScene.STATE_OUTRO       = "outro";